import axiosInstance from './config/api';
import { SMSStatistic } from 'types/sms.type';

export type GetSmsStatisticsParams = {
    id: string;
    startDate?: Date;
    endDate?: Date;
    partyStage?: string;
    smsStatus?: string;
    search?: string;
};

export const getSmsStatistics = (params: GetSmsStatisticsParams) => {
    const { id, startDate, endDate, ...rest } = params;
    const requestParams: Record<string, string | undefined> = { ...rest };
    if (startDate) requestParams.startDate = startDate.toISOString();
    if (endDate) requestParams.endDate = endDate.toISOString();

    return axiosInstance
        .get<{ smsStatistic: SMSStatistic }>(`/workflows/${id}/sms-statistics`, {
            params: requestParams,
        })
        .then((res) => res.data);
};
